exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".current-user {\n  display: inline-block;\n  text-align: right;\n  color: white;\n  line-height: 41px;\n  font-size: 13px;\n  letter-spacing: 0; }\n  .current-user .merchant-name {\n    display: inline-block; }\n    .current-user .merchant-name span {\n      padding-right: 10px; }\n    .current-user .merchant-name .merchant-spacer-hidden {\n      display: none; }\n  .current-user .username {\n    display: inline-block;\n    padding-right: 10px; }\n  .current-user a {\n    display: inline-block;\n    text-decoration: none;\n    color: #ffffff;\n    padding-right: 15px; }\n    .current-user a::visited {\n      color: #00c6d7; }\n    .current-user a:hover {\n      color: #00c6d7; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/User/components/CurrentUser/style.scss
// module id = 1020
// module chunks = 0